module.exports = __webpack_public_path__ + "img/berlin_logo.9f3380e1.png";